import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import './DesktopOnlyMessage.css';

const DesktopOnlyMessage = ({ show, onClose, onSecondary }) => {
  const { t } = useTranslation();

  const handleSecondary = () => {
    if (onSecondary) {
      onSecondary();
    } else {
      // sensible default: navigate to app root
      try {
        window.location.href = '/documents';
      } catch (e) {
        // ignore
      }
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered className="desktop-only-modal">
      <Modal.Header closeButton>
        <Modal.Title>{t('general.desktop_only_title')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{t('general.desktop_only_message')}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button className="primary" onClick={onClose}>{t('general.desktop_only_primary')}</Button>
        <Button className="reject" onClick={handleSecondary}>{t('general.desktop_only_secondary')}</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DesktopOnlyMessage;

